/**
 * Created by matos on 12/07/2017.
 */
export function PrivateNotificationMessage(options = {}) {

	let messageBlock = {
		// html layouts
		html_blocks: {
			messageBlock: `
			<div data-private-modal-id="hey" class="modal fade modal-content-clickable show" id="" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" data-backdrop="false" style="display: block; padding-right: 15px;">
			    <div class="modal-dialog modal-frame modal-top modal-notify" role="document">
			        <!--Content-->
			        <div class="modal-content">
			          <!--Header-->
			            <div class="modal-header">
			                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			                    <span aria-hidden="true"><i class="fa fa-window-close"></i></span>
			                </button>
			                <h4 class="modal-title w-100" id="">Modal title will be replaced</h4>
			            </div>
			            <!--Body-->
			            <div class="modal-body">
			                <div class="row px-4">
				                <div class="text-center">
									<div class="user_notification--content">
										<i data-tick class="fa fa-4x mb-1 animated "></i>
									</div>
								</div>
			                </div>
			            </div>
			             <!--Footer-->
			            <div class="modal-footer">
			            </div>
			        </div>
			        <!--/.Content-->
			    </div>
			</div>`,

			toasters: {
				default: ``
			},

			toastr_options: {
				"closeButton": true,
				"debug": false,
				"newestOnTop": false,
				"progressBar": false,
				"positionClass": "toast-top-right",
				"preventDuplicates": false,
				"onclick": null,
				"showDuration": "300",
				"hideDuration": "1000",
				"timeOut": "5000",
				"extendedTimeOut": "1000",
				"showEasing": "swing",
				"hideEasing": "linear",
				"showMethod": "fadeIn",
				"hideMethod": "fadeOut"
			}

		},

		/**
		 * Prepare the message
		 */
		message: function () {
			this.title = '';
			this.uuid = '';

			this.body = '';

			this.on_click = '';
			this.on_close = '';
			this.on_timed_close = '';

			this.notification_type = 'success';
			this.notification_types = {
				good: ['success', 'info'],
				bad: ['danger', 'warning']
			};

			this.timer = null;
			this.updateTextTimer = null;

			this.usesTimer = false;
			this.timeout = 0;

			this.jqueryObject = null;

			this.jqueryButtons = [];

			this.close = function () {
				this.jqueryObject.find(`.close`).click();
			}
		},

		/**
		 * Build the message block
		 * @param msg
		 * @param buttons
		 * @returns {*}
		 */
		buildBlock: function (msg, buttons) {
			msg.jqueryObject.attr('id', msg.uuid).addClass(msg.position_class);
			msg.jqueryObject.attr('aria-labelledby', msg.uuid + '-title');
			msg.jqueryObject.find('h4').html(msg.title);
			msg.jqueryObject.find('[role="document"]').addClass('modal-' + msg.notification_type);
			msg.jqueryObject.find('[data-tick]').addClass((msg.notification_types.good.indexOf(msg.notification_type) > -1) ? 'fa-check rotateIn' : 'fa-warning zoomIn');
			msg.jqueryObject.find(`.user_notification--content`).append(msg.body);

			msg.jqueryObject.on('hide.bs.modal', function (){
				eval(msg.on_close);
				clearTimeout(msg.timer);
				clearTimeout(msg.updateTextTimer);
			});

			msg.jqueryObject.on('hidden.bs.modal', function (){
				msg.jqueryObject.remove();
			});

			buttons.forEach(function (button) {
				let
					buildButton = `<button class="user_notification--footer-button btn btn-primary-modal waves-effect waves-light">${button[0]}</button>`,
					btn = $(buildButton);

				btn.click(function (e) {
					let notification = msg; //This is to be called by the event scripts

					e.preventDefault();
					e.stopPropagation();

					eval(button[1]);
				});

				msg.jqueryObject.find(`.modal-footer`).append(btn);
				msg.jqueryButtons.push(btn);
			});



			//Lets set the timer
			if (msg.usesTimer) {
				let
					time_left = Math.ceil(msg.timeout / 1000),
					need_update = false;

				//Write for the first time the correct time
				buttons.forEach(function (button, index) {
					let btn_text = button[0];

					if (btn_text.indexOf("%time%") !== -1){
						btn_text = btn_text.replace('%time%', time_left);
						msg.jqueryButtons[index].html(btn_text);

						need_update = true;
					}
				});

				//setting the general timer
				msg.timer = setTimeout(function () {
					eval(msg.on_timed_close);
					msg.close();
				}, msg.timeout);

				//setting an text updater timer
				if (need_update){
					msg.updateTextTimer = setInterval(function() {
						time_left--;

						buttons.forEach(function (button, index) {
							let btn_text = button[0];

							if (btn_text.indexOf("%time%") !== -1){
								btn_text = btn_text.replace('%time%', time_left);
								msg.jqueryButtons[index].html(btn_text);
							}
						});
					}, 1000);
				}
			}

			msg.jqueryObject.click(function (e) {
				eval(msg.on_click);
			});

			return msg.jqueryObject;
		},

		/**
		 * Set up the message and apply to the DOM
		 * @param data
		 */
		setup: function (data) {
			//creates a new message element
			let msg = new this.message();

			// execute alert because this one is the easiest :)
			if (data.elementType === 'alert' || data.elementType === 'toaster') {

				let toastr_options = {
					closeButton: data.options.closeButton || true,
					newestOnTop: data.options.newestOnTop || false,
					progressBar: data.options.progressBar || false,
					onclick: data.options.onClick || null,
					showDuration: data.options.showDuration || 300,
					hideDuration: data.options.hideDuration || 1000,
					showEasing: data.options.showEasing || "swing",
					hideEasing: data.options.hideEasing || "linear",
					showMethod: data.options.showMethod || "fadeIn",
					hideMethod: data.options.hideMethod || "fadeOut"
				};

				if (data.options.autoTimer){
					toastr_options.timeOut = data.options.timer || data.options.timeOut || 5000;
					toastr_options.extendedTimeOut = data.options.extendedTimeOut || data.options.timer || 1000;
				}

				if (data.options.position){
					toastr_options.positionClass = 'toast-' + data.options.position;
				}

				else {
					toastr_options.positionClass = data.options.positionClass || 'toast-top-right'
				}

				switch (data.notificationType) {
					//set position

					case 'info':
						window.toastr.info(data.htmlMessage, data.title, toastr_options);
						break;

					case 'success':
						window.toastr.success(data.htmlMessage, data.title, toastr_options);
						break;

					case 'danger':
					case 'error':
						window.toastr.error(data.htmlMessage, data.title, toastr_options);
						break;

					case 'warning':
						window.toastr.warning(data.htmlMessage, data.title, toastr_options);
						break;
				}

				return;
			}

			msg.position_class = data.options.position || data.options.positionClass || 'top';

			msg.title = data.title;
			msg.body = data.htmlMessage;
			msg.uuid = data.uuid;

			msg.notification_type = data.notificationType;

			msg.usesTimer = data.options.autoTimer || false;
			msg.timeout = data.options.timer || data.options.timeOut || 5000;

			msg.on_click = data.options.onClick || '';
			msg.on_close = data.options.onClose || '';
			msg.on_timed_close = data.options.onTimedClose || '';

			//creates a new copy of the standard block
			msg.jqueryObject = $(this.html_blocks.messageBlock);

			$(document.body).append(
				this.buildBlock(
					msg,
					data.options.buttons || [['Ok', 'notification.close();']]
				)
			);
			$('#' + data.uuid).modal({
				backdrop: true,
				keyboard: true
			}).on('hidden.bs.modal', function (e) {
				$(this).modal('hide');
				msg.close();
			});

		},

		init: function (options) {
			let
				_this = this,
				isTabActive = true,
				user_id = $(document.body).data('user_id');

			if (user_id > 0) {
				//Lets prepare the page for when active or inactive

				window.onfocus = function () {
					isTabActive = true;
				};
				window.onblur = function () {
					isTabActive = false;
				};


				window.CoreEcho.join(options.channel + "." + user_id)
					.listen('.__alive', function (e) {
						axios.post(e.url, {token: e.token})
					})
					.listen('.' + options.event, function (e) {
						if (isTabActive && (e.target === 'active' || e.target === 'all')){
							_this.setup(e.message);
						} else if (!isTabActive && (e.target === 'inactive' || e.target === 'all')){
							_this.setup(e.message);
						}
					});
			}
		}
	};

	messageBlock.init(options);
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/notifications/PrivateNotificationMessage.js